import { render, staticRenderFns } from "./MatchMakingModalCard.vue?vue&type=template&id=1f7bae54&scoped=true&"
import script from "./MatchMakingModalCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./MatchMakingModalCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MatchMakingModalCard.vue?vue&type=style&index=0&id=1f7bae54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7bae54",
  null
  
)

export default component.exports